import React from "react";
import { ParticipantIcon1 } from "../../icons/ParticipantIcon1";
import "./style.css";
import { Col, Row } from "react-bootstrap";

export const ParticipantIconText = ({
  className,
  text,
  icon = <ParticipantIcon1 className="uporabnik-icon" />,
}) => {
  let col1Size = 2;
  let col2Size = 8;
  let col3Size = 10;
  
  if (text === "UDELEŽENCI") {
    col1Size = 3;
    col2Size = 9;
    col3Size = 9;
  }
  return (
    // <div className={`uporabnik-icon-text ${className}`}>
    <Row className="d-inline-flex">
      <Col xs={col1Size} md={col1Size} lg={col1Size}>
        {icon}
      </Col>
      <Col xs={col2Size} md={col3Size} lg={col3Size} className="d-flex align-items-center">
        <div className="UDELE-ENEC-UDELE">{text}</div>
      </Col>
    </Row>
  );
};
